import { render } from "./SongView.vue?vue&type=template&id=1c819a40"
import script from "./SongView.vue?vue&type=script&lang=js"
export * from "./SongView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__